import React, { useContext, useEffect, useState } from 'react';
import { Col, Row, Stack, Image } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { LocaleContext } from 'routes/Router';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getProductListCallApi } from 'store/getProductList/action';
import { ClearTokenRedirectLogin } from 'utils/general';
import { getAllGategoryListCallApi } from 'store/getAllCategoryList/action';
import ArrowRightIcon from 'assets/images/Dashboard/ArrowRight-request.svg';
import CommonModal from 'components/commom/Modal';
import CrossIcon from 'assets/images/Dashboard/cross.svg';
import Shimmer from 'components/commom/Shimmer';
import EmptyScreen from 'assets/images/Dashboard/empty.svg';
import Loader from 'components/commom/Loader';
import CommonToast from 'components/commom/CommonToast';

const Product = () => {
  const { locale } = useContext(LocaleContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showToast } = CommonToast();
  const [expanded, setExpanded] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [showModalData, setShowModalData] = useState('');
  const [categoryList, setCategoryList] = useState([]);
  const [productList, setProductList] = useState([]);

  const categoryLoading = useSelector(
    (state) => state?.getAllCategoryListReducer?.loading
  );

  const productListLoading = useSelector(
    (state) => state?.getProductListReducer?.loading
  );

  const handleChange = (panel, key) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
    getProductListData(key?.category_id);
  };

  useEffect(() => {
    getAllCategoryListData();
  }, []);

  const getAllCategoryListData = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setCategoryList(res?.data);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getAllGategoryListCallApi(external));
  };

  const getProductListData = (categoryId) => {
    const external = {
      categoryId,
      run: true,
      handleFunction: (res) => {
        setProductList(res?.data);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getProductListCallApi(external));
  };

  const HtmlRenderer = ({ htmlString }) => {
    return <div dangerouslySetInnerHTML={{ __html: htmlString }} />;
  };

  const getHtmlToTextContent = (htmlData) => {
    return <HtmlRenderer htmlString={htmlData} />;
  };

  const handleModal = (data) => {
    setShowModalData(data);
    setIsModal(true);
  };

  return (
    <div>
      <Row className="bc-FEF9F6 m-0 p-0">
        <Col
          className={
            locale === 'en'
              ? 'commonEnContainer lg:ml-left border-l bColor-EFE3D7'
              : 'commonArContainer lg:mr-right border-l bColor-EFE3D7'
          }
        >
          <h2 className="fc-292D32 fs-32 family_outfit_semiBold_600 lh-4032  m-0">
            <FormattedMessage id="Product" />
          </h2>

          <Row className="mt-3 p-0 m-0">
            {categoryLoading ? (
              <Loader />
            ) : categoryList && categoryList.length > 0 ? (
              categoryList.map((key, index) => (
                <Row className="mt-3 p-0 m-0">
                  <Accordion
                    expanded={expanded === 'panel' + index}
                    onChange={handleChange('panel' + index, key)}
                    sx={{
                      boxShadow: 'none',
                      '&::before': {
                        display: 'none',
                      },
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1bh-content"
                      id="panel1bh-header"
                    >
                      <Row>
                        <p className="items-center p-16 m-0 fs-18 family_outfit_medium_500 fc-202224">
                          {key?.name}
                        </p>
                      </Row>
                    </AccordionSummary>

                    {productListLoading ? (
                      <>
                        {[1, 2].map((ietm) => (
                          <AccordionDetails>
                            <Row>
                              <Col lg={10} md={10} sm={12}>
                                <Stack
                                  direction="horizontal"
                                  gap={5}
                                  className="items-start"
                                >
                                  <Shimmer width="88px" height="88px" />

                                  <div className="flex-col">
                                    <p className="p-0 m-0 fs-16 family_outfit_medium_500 fc-202224">
                                      <Shimmer width="150px" height="16px" />
                                    </p>
                                    <p className="p-0 m-0 fs-14 family_outfit_regular_400 fc-A2ABB5">
                                      <Shimmer
                                        width="150px"
                                        height="16px"
                                        marginTop={'10px'}
                                      />
                                    </p>
                                    <p className="p-0 m-0 fs-16 family_outfit_semiBold_600 fc-202224">
                                      <Shimmer
                                        width="150px"
                                        height="16px"
                                        marginTop={'10px'}
                                      />
                                    </p>
                                  </div>
                                </Stack>
                              </Col>

                              <Col lg={2} md={2} sm={2}>
                                <Stack
                                  direction="horizontal"
                                  gap={1}
                                  className="items-center cursor-pointer justify-end"
                                >
                                  <div className="fs-14 fc-202224 lh-176 family_outfit_medium_500 underline underline-offset-4">
                                    <Shimmer width="100px" height="16px" />
                                  </div>
                                  <Shimmer width="30px" height="16px" />
                                </Stack>
                              </Col>
                            </Row>
                          </AccordionDetails>
                        ))}
                      </>
                    ) : productList && productList?.length > 0 ? (
                      productList.map((key, index) => (
                        <>
                          <AccordionDetails>
                            <Row>
                              <Col lg={10} md={10} sm={12}>
                                <Stack
                                  direction="horizontal"
                                  gap={5}
                                  className="items-start"
                                >
                                  {productListLoading ? (
                                    <Shimmer
                                      width="88px"
                                      height="88px"
                                      borderRadius="50%"
                                    />
                                  ) : (
                                    <img
                                      src={key?.node?.featuredImage?.url}
                                      alt="image"
                                      style={{ height: '88px', width: '88px' }}
                                    />
                                  )}

                                  <div className="flex-col">
                                    <p className="p-0 m-0 fs-16 family_outfit_medium_500 fc-202224">
                                      {key?.node?.title}
                                    </p>
                                    <p className="p-0 m-0 fs-14 family_outfit_regular_400 fc-A2ABB5">
                                      {key?.node?.line_category}
                                    </p>
                                    {/* <p className="p-0 m-0 fs-16 family_outfit_semiBold_600 fc-202224">
                                      {`$ ${
                                        key?.node?.variants?.edges?.[0]?.node
                                          ?.price
                                      }
                                      `}
                                    </p> */}
                                  </div>
                                </Stack>
                              </Col>

                              <Col lg={2} md={2} sm={2}>
                                <Stack
                                  direction="horizontal"
                                  gap={1}
                                  className="items-center cursor-pointer justify-end"
                                >
                                  <div
                                    className="fs-14 fc-202224 lh-176 family_outfit_medium_500 underline underline-offset-4"
                                    onClick={() => handleModal(key)}
                                  >
                                    <FormattedMessage id="View Details" />
                                  </div>
                                  <Image
                                    src={ArrowRightIcon}
                                    alt="icon"
                                    onClick={() => handleModal(key)}
                                  />
                                </Stack>
                              </Col>
                            </Row>
                          </AccordionDetails>
                          {index + 1 < productList?.length && <hr />}
                        </>
                      ))
                    ) : (
                      <AccordionDetails>
                        <Row>
                          <Col
                            lg={12}
                            md={12}
                            sm={12}
                            className="flex items-center justify-center"
                          >
                            <p className="p-0 m-0 fs-14 family_outfit_regular_400 fc-A2ABB5">
                              {'No Product found'}
                            </p>
                          </Col>
                        </Row>
                      </AccordionDetails>
                    )}
                  </Accordion>
                </Row>
              ))
            ) : (
              <div className="flex justify-center pt-120">
                <div>
                  <Image src={EmptyScreen} alt="icon" />
                  <div className="fs-20 fc-3C3C3C lh-2 family_outfit_medium_500 text-center	pt-30">
                    Nothing here yet
                  </div>
                </div>
              </div>
            )}
          </Row>

          {/* /////////////////////////////////////////////////ProductDetailsModal//////////// */}

          <CommonModal
            padding={'24px'}
            width={'800px'}
            modalActive={isModal}
            innerContent={
              <Row className="p-0 m-0 overflow-y-auto scrollbar-hide max-h-[600px]">
                <Row className="p-0 m-0">
                  <Col lg={10} md={10} sm={10} className="mt-2">
                    <p className="p-0 m-0 fs-18 family_outfit_medium_500 fc-202224">
                      {showModalData?.node?.title}
                    </p>
                    <p className="p-0 m-0 fs-14 family_outfit_regular_400 fc-A2ABB5">
                      {showModalData?.node?.category?.name}
                    </p>
                  </Col>
                  <Col
                    lg={2}
                    md={2}
                    sm={2}
                    className="mt-2 flex justify-end text-end"
                  >
                    <Image
                      src={CrossIcon}
                      style={{ height: '20px', width: '20px' }}
                      alt="icon"
                      className="cursor-pointer"
                      onClick={() => setIsModal(false)}
                    />
                  </Col>
                </Row>

                <Col lg={12} md={12} sm={12} className="mt-3">
                  <Stack direction="horizontal" gap={5}>
                    <img
                      src={showModalData?.node?.featuredImage?.url}
                      alt="image"
                      style={{ height: '88px', width: '88px' }}
                    />

                    <div className="flex-col">
                      <p className="p-0 m-0 mb-2 fs-18 family_outfit_medium_500 fc-202224">
                        {'Product Detail'}
                      </p>
                      {getHtmlToTextContent(
                        showModalData?.node?.descriptionHtml
                      )}
                    </div>
                  </Stack>
                </Col>
              </Row>
            }
          />

          {/* /////////////////////////////////////////////////ProductDetailsModal//////////// */}
        </Col>
      </Row>
    </div>
  );
};

export default Product;
